module.exports = __webpack_public_path__ + "img/item1.20c4a45b.png";